<template>
  <exo-help-dialog title="Frequency">
    <p>
      This is the frequency at which the spacecraft and ground stations
      communicate, typically between 300 MHz and 300 GHz. It is used to compute
      the ionosphere, atmospheric and free-space path losses (<katex-element
        expression="L_{ion}"
      />, <katex-element expression=" L_{atm}" /> and
      <katex-element expression="L_{FSPL}" /> respectively).
    </p>
    <p>
      The <strong>ionosphere loss</strong> accounts for the absorption of the
      radio waves when passing throught the ionosphere. It is mostly a function
      of the frequency, and in lower frequencies (below 100 MHz) it can be as
      high as tens of dB. In space<strong>studio</strong>, it is implemented as
      a piecewise linear function, starting from 0.7 dB at 146 MHz up to 0.1 dB
      at 2410 MHz (and 0 dB beyond that).
    </p>
    <p>
      The <strong>atmospheric loss</strong> accounts for the absorption of the
      radio waves when passing throught the atmospheric gases, specially Oxygen
      and water vapour. It decreases with the elevation and generally increases
      with frequency, with peaks around 22 GHz, 60 GHz, 120 GHz, 180 GHz and 325
      GHz. In space<strong>studio</strong>, it is implemented as described in
      Annex 2 of the recommendation P.676-3 from the International
      Telecommunication Union (ITU), with average values of air pressure,
      temperature and water vapour density of 1 atm, 15 °C and 7.5 g/m³
      respectively. The model is valid for frequencies between 1 GHz and 350
      GHz. At lower frequencies, the losses are computed as if it was at 1 GHz,
      and it serves as a conservative approximation (&lt1 dB at zenith).
    </p>
    <p>
      The <strong>free-space path loss</strong> is defined by the IEEE as the
      loss between two isotropic radiators in free space, expressed as a power
      ratio. It is given (in <katex-element expression="dB" />) by:
    </p>
    <p>
      <katex-element
        expression="L_{FSPL} = 10 \log{ \left (  \frac{4 \pi d f}{c}  \right )^2 }"
      />
    </p>
    <p>where:</p>
    <ul>
      <li>
        <katex-element expression="d" /> is the distance from the transmitter to
        the receiver, or slant range (<katex-element expression="m" />);
      </li>
      <li>
        <katex-element expression="f" /> is the signal frequency (<katex-element
          expression="Hz"
        />);
      </li>
      <li>
        <katex-element expression="c = 2.997925 \times 10^8" /> is the speed of
        light (<katex-element expression="m/s" />);
      </li>
    </ul>
    <br />
    <tooltipEquationEnvironmentalLosses />
    <tooltipEquationEbN0 />
  </exo-help-dialog>
</template>

<script>
import tooltipEquationEnvironmentalLosses from './tooltipEquationEnvironmentalLosses.vue'
import tooltipEquationEbN0 from './tooltipEquationEbN0.vue'
export default {
  name: 'tooltipFrequency',
  components: {
    tooltipEquationEnvironmentalLosses,
    tooltipEquationEbN0
  }
}
</script>
